/**
 * ETP Icon Slider – initialises Splide.js on every .etp-icon-slider element.
 *
 * Splide options are defined directly in this module.
 * Splide is enqueued by the PHP element via wp_enqueue_script('bricks-splide'),
 * so window.Splide is available.
 */

export function initIconSlider(scope) {
  const roots = (scope || document).querySelectorAll(
    '.etp-icon-slider:not([data-etp-icon-ready]), .brxe-etp-icon-slider:not([data-etp-icon-ready])'
  );

  // Hardcoded desktop-first Splide options. Breakpoints aligned with SCSS
  // token system: 1440 = bp-l, 1280 = bp-m.
  // > 1440px : 3 slides + 120 px peek
  // <= 1440px : 2 slides + 80 px peek
  // <= 1280px : 2 slides, no peek
  const options = {
    type: 'loop',
    perPage: 3,
    perMove: 1,
    gap: '12px',
    padding: { right: '120px' },
    arrows: true,
    pagination: false,
    rewind: true,
    mediaQuery: 'max',
    breakpoints: {
      1440: { perPage: 2, padding: { right: '80px' } },
      1280: { perPage: 2, padding: { right: '0px' } }
    }
  };

  roots.forEach((el) => {
    if (!window.Splide) {
      console.warn('[ETP icon-slider] window.Splide missing.');
      return;
    }
    const hasTrack = !!el.querySelector('.splide__track');
    const hasList = !!el.querySelector('.splide__list');
    if (!hasTrack || !hasList) {
      // In Bricks builder the wrapper can appear before children are rendered.
      console.warn('[ETP icon-slider] skip init, incomplete markup.');
      return;
    }

    try {
      const splide = new window.Splide(el, options);
      splide.mount();
      el.dataset.etpIconReady = 'true';
    } catch (e) {
      console.warn('[ETP icon-slider] init failed.', e);
    }
  });
}
